var isTurning = false;

var zoom = zoom || {};
zoom = {
    zoomSelector: '.zoom-drag',
    addZoom: function() {
        if ($('.wrapper .zoom-container').length < 1) return;
        $('.zoom-container').appendTo('body');
    },
    scale: 1,
    scaleStep: 'ontouchmove' in window ? 0.01 : 0.05,
    minScale: 0,
    currentScale: 0,
    curPage: false,
    // fitW: true,
    setScale: true,
    distToTurn: 600,
    isDraggable: false,
    minTop: -1,
    maxTop: 0,
    minLeft: -1,
    maxLeft: 0,
    default: {
        top: 0,
        left: 0,
    },
    drag: {
        top: 0,
        left: 0,
    },
    maxMove: {
        top: 0,
        left: 0,
    },
    directions: {
        left: ['left', -1],
        right: ['left', 1],
        up: ['top', -1],
        down: ['top', 1],
    },
    setImgSize: function(zoomDirection) {
        var zoom = this;
        // var oldScale = zoom.scale;

        zoom.ih = zoom.img.get(0).naturalHeight;
        zoom.iw = zoom.img.get(0).naturalWidth;
        var neww = zoom.iw,
            newh = zoom.ih;

        if (zoom.setScale) {
            var lastH = $('.mag-page').height(),
                currentScale = lastH / zoom.ih;

            if (!zoomDirection || typeof zoomDirection === 'undefined') {
                if (!zoom.currentScale) {
                    zoom.minScale = Math.ceil((currentScale + zoom.scaleStep) * 10) / 10;
                    zoom.currentScale = zoom.minScale;
                }

                zoom.scale = zoom.currentScale;
            } else if (zoomDirection === 'in') {
                zoom.scale += zoom.scaleStep;
            } else {
                zoom.scale -= zoom.scaleStep;
            }

            zoom.currentScale = zoom.scale;

            newh = zoom.ih * zoom.scale;
            neww = zoom.iw * zoom.scale;
        }

        zoom.ih = newh;
        zoom.iw = neww;

        zoom.img.css('height', newh);
        zoom.img.css('width', neww);
    },
    makeDraggable: function() {
        var zoom = this,
            $window = $(window);

        if (!zoom.isDraggable) {
            zoom.img.on('mousedown.dbg touchstart.dbg', function(e) {
                e.preventDefault();

                var x0 = e.clientX ? e.clientX : e.originalEvent.touches[0].clientX,
                    y0 = e.clientY ? e.clientY : e.originalEvent.touches[0].clientY,
                    imgTop = zoom.img.position().top,
                    imgLeft = zoom.img.position().left;

                zoom.img.css('cursor', 'move');

                $window.on('mousemove.dbg touchmove.dbg', function(e) {
                    e.preventDefault();
                    var x = e.clientX ? e.clientX : e.originalEvent.touches[0].clientX,
                        y = e.clientY ? e.clientY : e.originalEvent.touches[0].clientY;

                    if (zoom.ih > zoom.wh) {
                        // высота картинки больше высоты окна
                        var newImgTop = imgTop - (y0 - y);
                        if (newImgTop >= zoom.minTop && newImgTop <= zoom.maxTop) {
                            zoom.img.css('top', newImgTop);
                        }
                    }

                    if (zoom.iw > zoom.ww) {
                        var newImgLeft = imgLeft - (x0 - x);
                        if (newImgLeft >= zoom.minLeft && newImgLeft <= zoom.maxLeft) {
                            zoom.img.css('left', newImgLeft);
                        }
                    }
                });

                $window.on('mouseup.dbg touchend.dbg mouseleave.dbg', function() {
                    zoom.img.css('cursor', 'pointer');

                    $window.off('mousemove.dbg touchmove.dbg');
                    $window.off('mouseup.dbg touchend.dbg mouseleave.dbg');
                });
            });

            zoom.isDraggable = true;
        }
    },
    destroyDraggable: function() {
        var zoom = this;

        if (zoom.isDraggable) {
            zoom.img.unbind('mousedown.dbg touchstart.dbg');
            zoom.isDraggable = false;
        }
    },
    initSizes: function(zoomDirection, offsetX, offsetY, clientX, clientY) {
        var zoom = this,
            tmp;

        zoom.default = {
            top: 0,
            left: 0,
        };
        zoom.ww = $('.zoom-img').width();
        zoom.wh = $('.zoom-img').height();
        zoom.img = $('.zoom-drag__img');

        zoom.setImgSize(zoomDirection);

        if (zoomDirection) {
            zoom.img.css('-moz-transition', 'none');
            zoom.img.css('-webkit-transition', 'none');
            zoom.img.css('-o-transition', 'color 0 ease-in');
            zoom.img.css('transition', 'none');
        }

        zoom.maxMove.left = zoom.ww - zoom.iw;
        zoom.maxMove.top = zoom.wh - zoom.ih;

        zoom.minTop = zoom.wh - zoom.ih;
        zoom.minLeft = zoom.ww - zoom.iw;

        // если картинка не вмещается на экране, то нужно отцентрировать при изменении зума
        if ((zoomDirection === 'in' || zoomDirection === 'out') && (zoom.ih > zoom.wh || zoom.iw > zoom.ww)) {
            // дальше сложнее

            // var newTop, newLeft;
            //
            // if (zoom.ih > zoom.wh) {
            //     if (clientY < zoom.wh / 2) { // если курсор находится в верхней части экрана
            //         newTop = zoom.maxTop;
            //     } else { // если в нижней
            //         newTop = zoom.minTop;
            //     }
            // } else {
            //     newTop = Math.floor(-(zoom.ih - zoom.wh) / 2);
            // }
            //
            // if (zoom.iw > zoom.ww) {
            //     if (clientX > zoom.ww / 2) { // если курсор находится в правой части экрана
            //         newLeft = zoom.minLeft;
            //     } else { // если в левой части
            //         newLeft = zoom.maxLeft;
            //     }
            // } else {
            //     newLeft = Math.floor(-(zoom.iw - zoom.ww) / 2);
            // }
            //
            // zoom.img.css('top', newTop);
            // zoom.img.css('left', newLeft);

            var relationX = offsetX / zoom.iw;
            var relationY = offsetY / zoom.ih;

            var scaleFactor = zoomDirection === 'in' ? zoom.scale + zoom.scaleStep : zoom.scale - zoom.scaleStep;

            var naturalWidth = zoom.img[0].naturalWidth;
            var naturalHeight = zoom.img[0].naturalHeight;

            var deltaX = (naturalWidth * scaleFactor - zoom.iw) * relationX;
            var deltaY = (naturalHeight * scaleFactor - zoom.ih) * relationY;

            var left = zoom.img.position().left - deltaX;
            var top = zoom.img.position().top - deltaY;

            if (zoom.iw < zoom.ww) {
                left = Math.floor(-(zoom.iw - zoom.ww) / 2);
            } else if (left > 0) {
                left = 0;
            } else if (left + zoom.iw < zoom.ww) {
                left = zoom.ww - zoom.iw;
            }

            if (zoom.ih < zoom.wh) {
                top = Math.floor(-(zoom.ih - zoom.wh) / 2);
            } else if (top > 0) {
                top = 0;
            } else if (top + zoom.ih < zoom.wh) {
                top = zoom.wh - zoom.ih;
            }

            zoom.img.css('left', left);
            zoom.img.css('top', top);
        } else {
            if (zoom.iw < zoom.ww) {
                tmp = Math.floor(-(zoom.iw - zoom.ww) / 2);
                zoom.default.left = tmp;
                zoom.maxMove.left = tmp;
            }

            if (zoom.ih < zoom.wh) {
                tmp = Math.floor(-(zoom.ih - zoom.wh) / 2);
                zoom.default.top = tmp;
                zoom.maxMove.top = tmp;
            }

            zoom.makeDraggable();

            if (zoom.ih < zoom.wh && zoom.iw < zoom.ww) {
                zoom.destroyDraggable();
            }

            zoom.img.css('top', zoom.default.top);
            zoom.img.css('left', zoom.default.left);
        }
    },
    touchInit: function() {
        var zoom = this;

        zoom.initSizes(0);
        // zoom.setImgSize();

        $('.zoom-drag__img').swipe({
            pinchStatus: function(event, phase, direction, distance, duration) {
                if (!(event.touches && event.touches[1])) {
                    return;
                }

                event.preventDefault();
                // event.stopPropogation();

                var x1 = event.touches[0].clientX,
                    x2 = event.touches[1].clientX,
                    y1 = event.touches[0].clientY,
                    y2 = event.touches[1].clientY;

                var centerX = Math.max(x1, x2) - Math.abs(x1 - x2) / 2;
                var centerY = Math.max(y1, y2) - Math.abs(y1 - y2) / 2;

                if (direction === 'in' && phase === 'move') {
                    if (zoom.scale < 1) {
                        zoom.initSizes('in', centerX, centerY, centerX, centerY);
                    }
                } else if (direction === 'out') {
                    if (zoom.scale > zoom.minScale && phase === 'move') {
                        zoom.initSizes('out', centerX, centerY, centerX, centerY);
                    }
                }
            },
            fingers: 2,
            pinchThreshold: 0,
        });
    },
    moveImg: function(distance, direction) {
        var zoom = this,
            dir = zoom.directions[direction][0],
            coef = zoom.directions[direction][1] * 2;

        zoom.drag[dir] += distance * coef;

        if (zoom.drag[dir] > zoom.default[dir]) {
            var dst = zoom.drag[dir] - zoom.default[dir];
            zoom.drag[dir] = zoom.default[dir];

            if (dir == 'left' && dst > zoom.distToTurn) {
                zoom.setPrev();
            }
        }

        if (zoom.drag[dir] < zoom.maxMove[dir]) {
            var dst = zoom.maxMove[dir] - zoom.drag[dir];

            if (dir == 'left' && dst > zoom.distToTurn) {
                zoom.setNext();
                zoom.drag[dir] = zoom.default[dir];
            } else {
                zoom.drag[dir] = zoom.maxMove[dir];
            }
        }

        zoom.img.css(dir, zoom.drag[dir]);

        $('.zoom-container .msg.msg_on').removeClass('msg_on');
    },
    reInit: function(url) {
        $('.zoom-container .zoom-drag__img')
            .attr('src', url)
            .on('load', function() {
                zoom.initSizes();
            });
    },
    getIndex: function() {
        zoom.imgUrls = $('.flipbook')
            .data('img-urls')
            .split(',');
        var url = $('.zoom-drag__img').attr('src');
        var ind;
        for (var i = 0; i < zoom.imgUrls.length; i++) {
            if (url.indexOf(zoom.imgUrls[i]) >= 0) {
                ind = i;
                break;
            }
        }
        return ind;
    },
    setNext: function() {
        var zoom = this;
        // console.log('next');
        // console.log('next',zoom);
        var ind = zoom.getIndex();
        if (ind < zoom.imgUrls.length - 1) {
            // сложно понять нужно ли перелистывать страницу в флипбуке
            // этот код не работает в журналах 2009, требуется больше работ и исследований, чтобы сделать как надо
            if (ind !== 1) {
                $('.flipbook').turn('next');
            }

            zoom.reInit(zoom.imgUrls[ind + 1]);
        } else {
            console.log('end of book');
        }

        clearSelection();
    },
    setPrev: function() {
        var ind = zoom.getIndex();
        if (ind > 0) {
            if (ind !== 2) {
                $('.flipbook').turn('previous');
            }
            zoom.reInit(zoom.imgUrls[ind - 1]);
        } else {
            console.log('start of book');
        }

        clearSelection();
    },
    initZoom: function() {
        var zoom = this;
        var getPage = function() {
            var flipbook = $('.flipbook');
            var page = flipbook.turn('page');

            zoom.curPage = page;
            return page;
        };
        var getUrl = function(page) {
            var page = $('.flipbook .page-wrapper[page=' + page + '] .mag-page');
            // var flipbook = $('.flipbook');
            try {
                var url = page.css('background-image');
                url = url.match(/url\(["|']?([^"']*)["|']?\)/)[1];
            } catch (e) {
                console.info(e);
            }
            return url || false;
        };
        var nextPrevInit = function() {
            $('.zoom-icon-next')
                .unbind()
                .click(function() {
                    zoom.setNext();
                });
            $('.zoom-icon-prev')
                .unbind()
                .click(function() {
                    zoom.setPrev();
                });
        };
        var init = function() {
            zoom.touchInit();
        };
        var zoomActivate = function(mixed) {
            if (isTurning) return;

            var url;
            if (
                mixed &&
                mixed.hasOwnProperty('target') &&
                $(mixed.target)
                    .parent()
                    .parent()
                    .attr('page')
            ) {
                url = getUrl(
                    $(mixed.target)
                        .parent()
                        .parent()
                        .attr('page'),
                );
            } else {
                do {
                    url = getUrl(getPage());
                } while (!url);
            }
            $('.zoom-container')
                .addClass('visible')
                .find('img')
                .attr('src', url)
                .on('load', function() {
                    init();
                    nextPrevInit();
                });
        };
        var destroy = function() {
            $('.zoom-container')
                .removeClass('visible')
                .find('img')
                .unbind('load');
            $('.zoom-icon-next').unbind();
            $('.zoom-icon-prev').unbind();
        };
        $('.zoom-icon-in').click(zoomActivate);
        $('.flipbook').dblclick(zoomActivate);
        $('.zoom-icon-out').mousedown(destroy);
        $('.zoom-icon-close').mousedown(function() {
            zoom.destroy();
            $.magnificPopup.close();
        });

        zoom.destroy = destroy;
        jQuery('.flipbook').on('mousewheel', function(event, delta) {
            if (delta > 0) {
                // увеличение
                zoomActivate(event);
            }
        });

        $('.zoom-drag__img').on('mousewheel', function(event, delta) {
            if ('ontouchmove' in window) return;

            if (delta > 0) {
                // увеличение
                if (zoom.scale < 1) {
                    zoom.initSizes('in', event.offsetX, event.offsetY, event.clientX, event.clientY);
                }
            } else {
                if (zoom.scale > zoom.minScale) {
                    zoom.initSizes('out', event.offsetX, event.offsetY, event.clientX, event.clientY);
                } else {
                    zoom.destroy();
                }
            }
        });
    },
};

function clearSelection() {
    if (document.selection) {
        document.selection.empty();
    } else if (window.getSelection) {
        window.getSelection().removeAllRanges();
    }
}

function mfpInit() {
    var btnSel = '.js-mfp-link',
        btn = $(btnSel),
        wrap = '.mfp-wrap';
    btn.magnificPopup({
        type: 'ajax',
        tLoading: '<div class="svg-preloader-pdf"></div>',
        closeOnBgClick: false,
        showCloseBtn: false,
        fixedContentPos: true,
        callbacks: {
            parseAjax: function(mfpResponse) {
                if (typeof mfpResponse.data.html !== 'undefined') {
                    mfpResponse.data = mfpResponse.data.html;
                }
            },
            ajaxContentAdded: function ajaxContentAdded(mfpResponse) {
                initSizes();
                loadApp();

                $(window).on('resize', function () {
                    var flipbook = $('.flipbook');
                    initSizes();
                    flipbook.turn('resize');
                    flipbook.turn('size', flipbook.width(), flipbook.height());
                    fixCropedPages();
                    zoom.initSizes(0);
                });
            },
            close: function close() {
                $(window).off('resize');
            }
        }
    });
    $('body').on('click', btnSel, function () {
        var $btn = $(this);
        if ($btn.data('mfp-class').length) $(wrap).addClass($btn.data('mfp-class'));
    });
}

function fixCropedPages() {
    var $pages = $('.flipbook .page.odd:not(.p1)');

    $pages.each(function() {
        var $this = $(this);
        var w = $this.width();
        $this.children('.mag-page').css('margin-left', -w);
    });
}

function loadApp() {
    var flipbook = $('.flipbook');
    if (flipbook.width() == 0 || flipbook.height() == 0) {
        setTimeout(loadApp, 10);
        return;
    }
    var dspl = $('.flipbook').attr('data-disp-mode') || 'double';
    // dspl='double';
    if (dspl == 'double') {
        $('.flipbook .double.crop').scissor();
    }
    flipbook.turn({
        elevation: 10,
        gradients: true,
        autoCenter: true,
        display: dspl,
        acceleration: true,
        when: {
            turning: function(event, page, view) {
                isTurning = true;

                var pageCount = $(this).turn('pages');
                updateCounters(page, pageCount);

                fixCropedPages();
                initSizes();
            },
            turned: function(event, page, view) {
                if (page == 1) $(this).turn('peel', 'br');
                isTurning = false;
                console.log($(this).turn('pages'), page, $('.mag-page'))
                if (page > 1) {
                    // console.log('показываем левый контрол');
                    $('.pdf-slider__controls-prev')
                        .css('opacity', 1)
                        .css('cursor', 'pointer');
                } else {
                    // console.log('скрываемы левый контрол');
                    $('.pdf-slider__controls-prev')
                        .css('opacity', 0)
                        .css('cursor', 'default');
                };
                if (page < $(this).turn('pages')) {
                    // console.log('показываем правый контрол');
                    $('.pdf-slider__controls-next')
                        .css('opacity', 1)
                        .css('cursor', 'pointer');
                } else {
                    // console.log('скрываемы правый контрол');
                    $('.pdf-slider__controls-next')
                        .css('opacity', 0)
                        .css('cursor', 'default');
                }
            },
        },
    });
    // Using arrow keys to turn the page
    $(document).keydown(function(e) {
        var previous = 37,
            next = 39,
            esc = 27;
        switch (e.keyCode) {
            case previous:
                // left arrow
                $('.flipbook').turn('previous');
                e.preventDefault();
                break;
            case next:
                // right arrow
                $('.flipbook').turn('next');
                e.preventDefault();
                break;
            case esc:
                // $('.flipbook-viewport').zoom('zoomOut');
                e.preventDefault();
                break;
        }
    });
    $('.pdf-slider__controls-next').on('click', function(e) {
        $('.flipbook').turn('next');
    });
    $('.pdf-slider__controls-prev').on('click', function(e) {
        $('.flipbook').turn('previous');
    });

    zoom.initZoom();
    $('.flipbook-viewport').addClass('loaded');
    $('head meta[name="viewport"]').attr(
        'content',
        'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no',
    );
}

function initSizes() {
    var wrap = $('.mfp-magazine'),
        box = $('.flipbook-popup_wrap'),
        aspect = box.find('.flipbook').data('aspect');
    if (box.length < 1) return;
    var wh = $(window).height() - $('.pdf-slider__controls-wrap').height(),
        ww = $(window).width(),
        w,
        h;
    if (ww / wh > aspect) {
        h = Math.floor(wh - 8);
        w = Math.floor(aspect * h);
    } else {
        w = Math.floor(ww - 8);
        h = Math.floor(w / aspect);
        wrap.addClass('mfp-vertical');
    }

    // h -= $('.pdf-slider__controls-wrap').height();
    w += 8;

    // if (ww < 1300)
    //     wrap.addClass('mfp-small');
    box.css('height', h);
    box.css('width', w);
    box.find('.set-h').css('height', h);
    box.find('.set-w').css('width', w);
    box.find('.set-h2').css('top', Math.floor(-h / 2));
    box.find('.set-w2').css('left', Math.floor(-w / 2));
    $('.wrapper').css('height', h + 100);
}

function setHeadWidth() {
    var $page = $('.flipbook .shadow');
    var $head = $('.pdf-slider__controls-wrap-inner');

    function set() {
        $head.css('max-width', $page.width());
    }

    $(window).on('resize', set);
}

function updateCounters(pageCurrent, pageCount) {
    var current = pageCurrent;

    if (pageCurrent % 2 === 0) {
        current = pageCurrent + '-' + (pageCurrent + 1);
    }

    if (pageCurrent % 2 === 1 && pageCurrent !== 1) {
        current = pageCurrent - 1 + '-' + pageCurrent;
    }

    var text = current + ' / ' + pageCount;
    $('.zoom-counter').text(text);
}

function replaceZoomContainer() {
    const $container = $('.js-flipbook-zoom');
    $container.appendTo('body');
}

$(document).ready(function() {
    zoom.addZoom();
    mfpInit();
    $('#out').appendTo('body');
    replaceZoomContainer();
});



// WEBPACK FOOTER //
// ./js/main/module/flipbook.js